<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>上游主缆</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气夹</div>
          <div class="sensor2">进气夹</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机组</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">黄石</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">黄冈</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left-anchor" content="黄石西锚室除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/anchorRoom/huangshiWest"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-left" content="黄石箱梁除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/steelBoxDehumidifier/huangshi"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-left-top" content="黄石主缆除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/mainCable/huangshi"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-right" content="黄冈箱梁除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/steelBoxDehumidifier/huanggang"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-right-top" content="黄冈主缆除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/mainCable/huanggang"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-right-anchor" content="黄冈西锚室除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/anchorRoom/huanggangWest"></router-link>
          </el-tooltip>

          <div class="stati sta-left-anchor">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    anchorRoomHuangshiWestHumidityTooltipError,
                    anchorRoomHuangshiWestHumidityAllowedMax,
                    anchorRoomHuangshiWestRunning,
                    anchorRoomHuangshiWestMalfunction
                  )
                }}
              </div>
              <div :class="anchorRoomHuangshiWestError" class="state-info right-pos">
                <p>黄石西锚室除湿机</p>
                <p>
                  <span>{{ anchorRoomHuangshiWestHumidity | toFixed }}% {{ anchorRoomHuangshiWestTemperature | toFixed }}°C</span>
                  <!-- <el-tooltip :content="anchorRoomHuangshiWestRunningTooltip" effect="light" placement="right"> -->
                  <span :class="anchorRoomHuangshiWestRunningClass" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-left-steelbox">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "黄石箱梁1",
                    steelBoxHuangshiHumidityTooltipError1,
                    steelBoxHuangshiHumidityAllowedMax1,
                    steelBoxHuangshiRunning1,
                    steelBoxHuangshiMalfunction1
                  )
                }}
              </div>
              <div :class="steelBoxHuangshiError1" class="state-info left-pos">
                <p>黄石箱梁除湿机1</p>
                <p>
                  <span>{{ steelBoxHuangshiHumidity1 | toFixed }}% {{ steelBoxHuangshiTemperature1 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="steelBoxHuangshiRunningTooltip1" effect="light" placement="right"> -->
                  <span :class="steelBoxHuangshiRunningClass1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-left-side-span">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    steelBoxSideSpanUpstreamTooltipError,
                    "",
                    steelBoxSideSpanUpstreamRunning,
                    steelBoxSideSpanUpstreamMalfunction
                  )
                }}
              </div>
              <div :class="steelBoxSideSpanUpstreamError" class="state-info right-pos">
                <p>南边跨上游除湿机</p>
                <p>
                  <span>除湿机状态</span>
                  <!-- <el-tooltip :content="steelBoxSideSpanUpstreamRunningTooltip" effect="light" placement="right"> -->
                  <span :class="steelBoxSideSpanUpstreamRunningClass" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-left-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    mainCableHuangshiHumidityTooltipError,
                    mainCableHuangshiHumidityAllowedMax,
                    mainCableHuangshiRunning,
                    mainCableHuangshiMalfunction
                  )
                }}
              </div>
              <div :class="mainCableHuangshiError" class="state-info right-pos">
                <p>黄石主缆除湿机</p>
                <p>
                  <span>{{ mainCableHuangshiHumidity | toFixed }}% {{ mainCableHuangshiTemperature | toFixed }}°C</span>
                  <!-- <el-tooltip :content="mainCableHuangshiRunningTooltip" effect="light" placement="right"> -->
                  <span :class="mainCableHuangshiRunningClass" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-right-steelbox">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    steelBoxHuanggangHumidityTooltipError1,
                    steelBoxHuanggangHumidityAllowedMax1,
                    steelBoxHuanggangRunning1,
                    steelBoxHuanggangMalfunction1
                  )
                }}
              </div>
              <div :class="steelBoxHuanggangError1" class="state-info left-pos">
                <p>黄冈箱梁除湿机1</p>
                <p>
                  <span>{{ steelBoxHuanggangHumidity1 | toFixed }}% {{ steelBoxHuanggangTemperature1 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="steelBoxHuanggangRunningTooltip1" effect="light" placement="right"> -->
                  <span :class="steelBoxHuanggangRunningClass1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-right-top">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    mainCableHuanggangHumidityTooltipError,
                    mainCableHuanggangHumidityAllowedMax,
                    mainCableHuanggangRunning,
                    mainCableHuanggangMalfunction
                  )
                }}
              </div>
              <div :class="mainCableHuanggangError" class="state-info left-pos">
                <p>黄冈主缆除湿机</p>
                <p>
                  <span>{{ mainCableHuanggangHumidity | toFixed }}% {{ mainCableHuanggangTemperature | toFixed }}°C</span>
                  <!-- <el-tooltip :content="mainCableHuanggangRunningTooltip" effect="light" placement="right"> -->
                  <span :class="mainCableHuanggangRunningClass" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-right-anchor">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    anchorRoomHuanggangWestHumidityTooltipError,
                    anchorRoomHuanggangWestHumidityAllowedMax,
                    anchorRoomHuanggangWestRunning,
                    anchorRoomHuanggangWestMalfunction
                  )
                }}
              </div>
              <div :class="anchorRoomHuanggangWestError" class="state-info left-pos">
                <p>黄冈西锚室除湿机</p>
                <p>
                  <span>{{ anchorRoomHuanggangWestHumidity | toFixed }}% {{ anchorRoomHuanggangWestTemperature | toFixed }}°C</span>
                  <!-- <el-tooltip :content="anchorRoomHuanggangWestRunningTooltip" effect="light" placement="right"> -->
                  <span :class="anchorRoomHuanggangWestRunningClass" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 left1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXP1, humidityAllowedMaxXP1) }}
              </div>
              <div :class="errorXP1" class="state-info right-pos">
                <p>XP1气夹</p>
                <p>{{ humidityXP1 | toFixed }}%</p>
                <p>{{ temperatureXP1 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 left2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXS1, humidityAllowedMaxXS1) }}
              </div>
              <div :class="errorXS1" class="state-info right-pos">
                <p>XS1气夹</p>
                <p>{{ humidityXS1 | toFixed }}%</p>
                <p>{{ temperatureXS1 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 left3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXP2, humidityAllowedMaxXP2) }}
              </div>
              <div :class="errorXP2" class="state-info right-pos">
                <p>XP2气夹</p>
                <p>{{ humidityXP2 | toFixed }}%</p>
                <p>{{ temperatureXP2 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 left4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXP3, humidityAllowedMaxXP3) }}
              </div>
              <div :class="errorXP3" class="state-info left-pos">
                <p>XP3气夹</p>
                <p>{{ humidityXP3 | toFixed }}%</p>
                <p>{{ temperatureXP3 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 left5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXS2, humidityAllowedMaxXS2) }}
              </div>
              <div :class="errorXS2" class="state-info left-pos">
                <p>XS2气夹</p>
                <p>{{ humidityXS2 | toFixed }}%</p>
                <p>{{ temperatureXS2 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 middle">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXP4, humidityAllowedMaxXP4) }}
              </div>
              <div :class="errorXP4" class="state-info left-pos">
                <p>XP4气夹</p>
                <p>{{ humidityXP4 | toFixed }}%</p>
                <p>{{ temperatureXP4 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 right5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXS3, humidityAllowedMaxXS3) }}
              </div>
              <div :class="errorXS3" class="state-info right-pos">
                <p>XS3气夹</p>
                <p>{{ humidityXS3 | toFixed }}%</p>
                <p>{{ temperatureXS3 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 right4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXP5, humidityAllowedMaxXP5) }}
              </div>
              <div :class="errorXP5" class="state-info right-pos">
                <p>XP5气夹</p>
                <p>{{ humidityXP5 | toFixed }}%</p>
                <p>{{ temperatureXP5 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 right3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXP6, humidityAllowedMaxXP6) }}
              </div>
              <div :class="errorXP6" class="state-info left-pos">
                <p>XP6气夹</p>
                <p>{{ humidityXP6 | toFixed }}%</p>
                <p>{{ temperatureXP6 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 right2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXS4, humidityAllowedMaxXS4) }}
              </div>
              <div :class="errorXS4" class="state-info left-pos">
                <p>XS4气夹</p>
                <p>{{ humidityXS4 | toFixed }}%</p>
                <p>{{ temperatureXS4 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 right1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorXP7, humidityAllowedMaxXP7) }}
              </div>
              <div :class="errorXP7" class="state-info left-pos">
                <p>XP7气夹</p>
                <p>{{ humidityXP7 | toFixed }}%</p>
                <p>{{ temperatureXP7 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>下游主缆</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">排气夹</div>
          <div class="sensor2">进气夹</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机组</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">黄石</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">黄冈</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left-anchor" content="黄石东锚室除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/anchorRoom/huangshiEast"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-left" content="黄石箱梁除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/saddleRoom"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-left-top" content="黄石侧鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/mainCable/huangshi"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-right" content="黄冈箱梁除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/saddleRoom"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-right-top" content="黄冈侧鞍室" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/mainCable/huanggang"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-right-anchor" content="黄冈东锚室除湿机" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/qipanzhou/anchorRoom/huanggangEast"></router-link>
          </el-tooltip>

          <div class="stati sta-left-anchor">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    anchorRoomHuangshiEastHumidityTooltipError,
                    anchorRoomHuangshiEastHumidityAllowedMax,
                    anchorRoomHuangshiEastRunning,
                    anchorRoomHuangshiEastMalfunction
                  )
                }}
              </div>
              <div :class="anchorRoomHuangshiEastError" class="state-info right-pos">
                <p>黄石东锚室除湿机</p>
                <p>
                  <span>{{ anchorRoomHuangshiEastHumidity | toFixed }}% {{ anchorRoomHuangshiEastTemperature | toFixed }}°C</span>
                  <!-- <el-tooltip :content="anchorRoomHuangshiEastRunningTooltip" effect="light" placement="right"> -->
                  <span :class="anchorRoomHuangshiEastRunningClass" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-left-steelbox">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    steelBoxHuangshiHumidityTooltipError2,
                    steelBoxHuangshiHumidityAllowedMax2,
                    steelBoxHuangshiRunning2,
                    steelBoxHuangshiMalfunction2
                  )
                }}
              </div>
              <div :class="steelBoxHuangshiError2" class="state-info left-pos">
                <p>黄石箱梁除湿机2</p>
                <p>
                  <span>{{ steelBoxHuangshiHumidity2 | toFixed }}% {{ steelBoxHuangshiTemperature2 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="steelBoxHuangshiRunningTooltip2" effect="light" placement="right"> -->
                  <span :class="steelBoxHuangshiRunningClass2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-left-side-span">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    steelBoxSideSpanDownstreamTooltipError,
                    "",
                    steelBoxSideSpanDownstreamRunning,
                    steelBoxSideSpanDownstreamMalfunction
                  )
                }}
              </div>
              <div :class="steelBoxSideSpanDownstreamError" class="state-info right-pos">
                <p>南边跨下游除湿机</p>
                <p>
                  <span>除湿机状态</span>
                  <!-- <el-tooltip :content="steelBoxSideSpanDownstreamRunningTooltip" effect="light" placement="right"> -->
                  <span :class="steelBoxSideSpanDownstreamRunningClass" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-left-top-saddle">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("上游", saddleRoomHuangshiUpstreamHumidityTooltipError, saddleRoomHuangshiUpstreamHumidityAllowedMax) }}
                <br />
                {{ assembleTooltip_sensor("下游", saddleRoomHuangshiDownstreamHumidityTooltipError, saddleRoomHuangshiDownstreamHumidityAllowedMax) }}
              </div>
              <div :class="saddleRoomHuangshiError" class="state-info right-pos">
                <p>黄石侧鞍室上游/下游</p>
                <p>
                  <span>{{ saddleRoomHuangshiUpstreamHumidity | toFixed }}% {{ saddleRoomHuangshiUpstreamTemperature | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ saddleRoomHuangshiDownstreamHumidity | toFixed }}% {{ saddleRoomHuangshiDownstreamTemperature | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-right-steelbox">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    steelBoxHuanggangHumidityTooltipError2,
                    steelBoxHuanggangHumidityAllowedMax2,
                    steelBoxHuanggangRunning2,
                    steelBoxHuanggangMalfunction2
                  )
                }}
              </div>
              <div :class="steelBoxHuanggangError2" class="state-info left-pos">
                <p>黄冈箱梁除湿机2</p>
                <p>
                  <span>{{ steelBoxHuanggangHumidity2 | toFixed }}% {{ steelBoxHuanggangTemperature2 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="steelBoxHuanggangRunningTooltip2" effect="light" placement="right"> -->
                  <span :class="steelBoxHuanggangRunningClass2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-right-top-saddle">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("上游", saddleRoomHuanggangUpstreamHumidityTooltipError, saddleRoomHuanggangUpstreamHumidityAllowedMax) }}
                <br />
                {{
                  assembleTooltip_sensor("下游", saddleRoomHuanggangDownstreamHumidityTooltipError, saddleRoomHuanggangDownstreamHumidityAllowedMax)
                }}
              </div>
              <div :class="saddleRoomHuanggangError" class="state-info left-pos">
                <p>黄冈侧鞍室上游/下游</p>
                <p>
                  <span>{{ saddleRoomHuanggangUpstreamHumidity | toFixed }}% {{ saddleRoomHuanggangUpstreamTemperature | toFixed }}°C</span>
                </p>
                <p>
                  <span>{{ saddleRoomHuanggangDownstreamHumidity | toFixed }}% {{ saddleRoomHuanggangDownstreamTemperature | toFixed }}°C</span>
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="stati sta-right-anchor">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    anchorRoomHuanggangEastHumidityTooltipError,
                    anchorRoomHuanggangEastHumidityAllowedMax,
                    anchorRoomHuanggangEastRunning,
                    anchorRoomHuanggangEastMalfunction
                  )
                }}
              </div>
              <div :class="anchorRoomHuanggangEastError" class="state-info left-pos">
                <p>黄冈东锚室除湿机</p>
                <p>
                  <span>{{ anchorRoomHuanggangEastHumidity | toFixed }}% {{ anchorRoomHuanggangEastTemperature | toFixed }}°C</span>
                  <!-- <el-tooltip :content="anchorRoomHuanggangEastRunningTooltip" effect="light" placement="right"> -->
                  <span :class="anchorRoomHuanggangEastRunningClass" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 left1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDP1, humidityAllowedMaxDP1) }}
              </div>
              <div :class="errorDP1" class="state-info right-pos">
                <p>DP1气夹</p>
                <p>{{ humidityDP1 | toFixed }}%</p>
                <p>{{ temperatureDP1 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 left2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDS1, humidityAllowedMaxDS1) }}
              </div>
              <div :class="errorDS1" class="state-info right-pos">
                <p>DS1气夹</p>
                <p>{{ humidityDS1 | toFixed }}%</p>
                <p>{{ temperatureDS1 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 left3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDP2, humidityAllowedMaxDP2) }}
              </div>
              <div :class="errorDP2" class="state-info right-pos">
                <p>DP2气夹</p>
                <p>{{ humidityDP2 | toFixed }}%</p>
                <p>{{ temperatureDP2 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 left4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDP3, humidityAllowedMaxDP3) }}
              </div>
              <div :class="errorDP3" class="state-info left-pos">
                <p>DP3气夹</p>
                <p>{{ humidityDP3 | toFixed }}%</p>
                <p>{{ temperatureDP3 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 left5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDS2, humidityAllowedMaxDS2) }}
              </div>
              <div :class="errorDS2" class="state-info left-pos">
                <p>DS2气夹</p>
                <p>{{ humidityDS2 | toFixed }}%</p>
                <p>{{ temperatureDS2 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 middle">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDP4, humidityAllowedMaxDP4) }}
              </div>
              <div :class="errorDP4" class="state-info left-pos">
                <p>DP4气夹</p>
                <p>{{ humidityDP4 | toFixed }}%</p>
                <p>{{ temperatureDP4 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 right5">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDS3, humidityAllowedMaxDS3) }}
              </div>
              <div :class="errorDS3" class="state-info right-pos">
                <p>DS3气夹</p>
                <p>{{ humidityDS3 | toFixed }}%</p>
                <p>{{ temperatureDS3 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 right4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDP5, humidityAllowedMaxDP5) }}
              </div>
              <div :class="errorDP5" class="state-info right-pos">
                <p>DP5气夹</p>
                <p>{{ humidityDP5 | toFixed }}%</p>
                <p>{{ temperatureDP5 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 right3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDP6, humidityAllowedMaxDP6) }}
              </div>
              <div :class="errorDP6" class="state-info left-pos">
                <p>DP6气夹</p>
                <p>{{ humidityDP6 | toFixed }}%</p>
                <p>{{ temperatureDP6 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 right2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDS4, humidityAllowedMaxDS4) }}
              </div>
              <div :class="errorDS4" class="state-info left-pos">
                <p>DS4气夹</p>
                <p>{{ humidityDS4 | toFixed }}%</p>
                <p>{{ temperatureDS4 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 right1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", humidityTooltipErrorDP7, humidityAllowedMaxDP7) }}
              </div>
              <div :class="errorDP7" class="state-info left-pos">
                <p>DP7气夹</p>
                <p>{{ humidityDP7 | toFixed }}%</p>
                <p>{{ temperatureDP7 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      humidityXP1: "--",
      temperatureXP1: "--",
      humidityXS1: "--",
      temperatureXS1: "--",
      humidityXP2: "--",
      temperatureXP2: "--",
      humidityXP3: "--",
      temperatureXP3: "--",
      humidityXS2: "--",
      temperatureXS2: "--",
      humidityXP4: "--",
      temperatureXP4: "--",
      humidityXS3: "--",
      temperatureXS3: "--",
      humidityXP5: "--",
      temperatureXP5: "--",
      humidityXP6: "--",
      temperatureXP6: "--",
      humidityXS4: "--",
      temperatureXS4: "--",
      humidityXP7: "--",
      temperatureXP7: "--",

      steelBoxHuangshiTemperature1: "--",
      steelBoxHuangshiHumidity1: "--",
      steelBoxHuangshiRunning1: "--",
      steelBoxHuangshiTemperature2: "--",
      steelBoxHuangshiHumidity2: "--",
      steelBoxHuangshiRunning2: "--",
      steelBoxHuanggangTemperature1: "--",
      steelBoxHuanggangHumidity1: "--",
      steelBoxHuanggangRunning1: "--",
      steelBoxHuanggangTemperature2: "--",
      steelBoxHuanggangHumidity2: "--",
      steelBoxHuanggangRunning2: "--",

      mainCableHuanggangHumidity: "--",
      mainCableHuanggangTemperature: "--",
      mainCableHuanggangRunning: "--",
      mainCableHuangshiHumidity: "--",
      mainCableHuangshiTemperature: "--",
      mainCableHuangshiRunning: "--",

      anchorRoomHuangshiWestTemperature: "--",
      anchorRoomHuangshiWestHumidity: "--",
      anchorRoomHuangshiWestRunning: "--",
      anchorRoomHuanggangWestTemperature: "--",
      anchorRoomHuanggangWestHumidity: "--",
      anchorRoomHuanggangWestRunning: "--",
      anchorRoomHuangshiEastTemperature: "--",
      anchorRoomHuangshiEastHumidity: "--",
      anchorRoomHuangshiEastRunning: "--",
      anchorRoomHuanggangEastTemperature: "--",
      anchorRoomHuanggangEastHumidity: "--",
      anchorRoomHuanggangEastRunning: "--",
      steelBoxSideSpanUpstreamRunning: "--",
      steelBoxSideSpanDownstreamRunning: "--",

      saddleRoomHuangshiUpstreamTemperature: "--",
      saddleRoomHuangshiUpstreamHumidity: "--",
      saddleRoomHuangshiDownstreamTemperature: "--",
      saddleRoomHuangshiDownstreamHumidity: "--",
      saddleRoomHuanggangUpstreamTemperature: "--",
      saddleRoomHuanggangUpstreamHumidity: "--",
      saddleRoomHuanggangDownstreamTemperature: "--",
      saddleRoomHuanggangDownstreamHumidity: "--",

      humidityDP1: "--",
      temperatureDP1: "--",
      humidityDS1: "--",
      temperatureDS1: "--",
      humidityDP2: "--",
      temperatureDP2: "--",
      humidityDP3: "--",
      temperatureDP3: "--",
      humidityDS2: "--",
      temperatureDS2: "--",
      humidityDP4: "--",
      temperatureDP4: "--",
      humidityDS3: "--",
      temperatureDS3: "--",
      humidityDP5: "--",
      temperatureDP5: "--",
      humidityDP6: "--",
      temperatureDP6: "--",
      humidityDS4: "--",
      temperatureDS4: "--",
      humidityDP7: "--",
      temperatureDP7: "--",

      errorXP1: "",
      errorXS1: "",
      errorXP2: "",
      errorXP3: "",
      errorXS2: "",
      errorXP4: "",
      errorXS3: "",
      errorXP5: "",
      errorXP6: "",
      errorXS4: "",
      errorXP7: "",

      steelBoxHuangshiError1: "",
      steelBoxHuangshiError2: "",
      steelBoxHuanggangError1: "",
      steelBoxHuanggangError2: "",
      mainCableHuangshiError: "",
      mainCableHuanggangError: "",
      anchorRoomHuangshiWestError: "",
      anchorRoomHuanggangWestError: "",
      anchorRoomHuangshiEastError: "",
      anchorRoomHuanggangEastError: "",
      steelBoxSideSpanUpstreamError: "",
      steelBoxSideSpanDownstreamError: "",
      saddleRoomHuangshiError: "",
      saddleRoomHuanggangError: "",

      errorDP1: "",
      errorDS1: "",
      errorDP2: "",
      errorDP3: "",
      errorDS2: "",
      errorDP4: "",
      errorDS3: "",
      errorDP5: "",
      errorDP6: "",
      errorDS4: "",
      errorDP7: "",

      // steelBoxHuangshiRunningTooltip1: "--",
      // steelBoxHuangshiRunningTooltip2: "--",
      // steelBoxHuanggangRunningTooltip1: "--",
      // steelBoxHuanggangRunningTooltip2: "--",
      // mainCableHuangshiRunningTooltip: "--",
      // mainCableHuanggangRunningTooltip: "--",
      // anchorRoomHuangshiWestRunningTooltip: "--",
      // anchorRoomHuanggangWestRunningTooltip: "--",
      // anchorRoomHuangshiEastRunningTooltip: "--",
      // anchorRoomHuanggangEastRunningTooltip: "--",
      // steelBoxSideSpanUpstreamRunningTooltip: "--",
      // steelBoxSideSpanDownstreamRunningTooltip: "--",

      steelBoxHuanggangRunningClass1: "",
      steelBoxHuanggangRunningClass2: "",
      steelBoxHuangshiRunningClass1: "",
      steelBoxHuangshiRunningClass2: "",
      mainCableHuangshiRunningClass: "",
      mainCableHuanggangRunningClass: "",
      anchorRoomHuangshiWestRunningClass: "--",
      anchorRoomHuanggangWestRunningClass: "--",
      anchorRoomHuangshiEastRunningClass: "--",
      anchorRoomHuanggangEastRunningClass: "--",
      steelBoxSideSpanUpstreamRunningClass: "--",
      steelBoxSideSpanDownstreamRunningClass: "--",

      //humidity allowed max
      humidityAllowedMaxXP1: "--",
      humidityAllowedMaxXS1: "--",
      humidityAllowedMaxXP2: "--",
      humidityAllowedMaxXP3: "--",
      humidityAllowedMaxXS2: "--",
      humidityAllowedMaxXP4: "--",
      humidityAllowedMaxXS3: "--",
      humidityAllowedMaxXP5: "--",
      humidityAllowedMaxXP6: "--",
      humidityAllowedMaxXS4: "--",
      humidityAllowedMaxXP7: "--",
      steelBoxHuangshiHumidityAllowedMax1: "--",
      steelBoxHuangshiHumidityAllowedMax2: "--",
      steelBoxHuanggangHumidityAllowedMax1: "--",
      steelBoxHuanggangHumidityAllowedMax2: "--",
      mainCableHuanggangHumidityAllowedMax: "--",
      mainCableHuangshiHumidityAllowedMax: "--",
      anchorRoomHuangshiWestHumidityAllowedMax: "--",
      anchorRoomHuanggangWestHumidityAllowedMax: "--",
      anchorRoomHuangshiEastHumidityAllowedMax: "--",
      anchorRoomHuanggangEastHumidityAllowedMax: "--",
      saddleRoomHuangshiUpstreamHumidityAllowedMax: "--",
      saddleRoomHuangshiDownstreamHumidityAllowedMax: "--",
      saddleRoomHuanggangUpstreamHumidityAllowedMax: "--",
      saddleRoomHuanggangDownstreamHumidityAllowedMax: "--",
      humidityAllowedMaxDP1: "--",
      humidityAllowedMaxDS1: "--",
      humidityAllowedMaxDP2: "--",
      humidityAllowedMaxDP3: "--",
      humidityAllowedMaxDS2: "--",
      humidityAllowedMaxDP4: "--",
      humidityAllowedMaxDS3: "--",
      humidityAllowedMaxDP5: "--",
      humidityAllowedMaxDP6: "--",
      humidityAllowedMaxDS4: "--",
      humidityAllowedMaxDP7: "--",

      //humidity tooltip error
      humidityTooltipErrorXP1: "--",
      humidityTooltipErrorXS1: "--",
      humidityTooltipErrorXP2: "--",
      humidityTooltipErrorXP3: "--",
      humidityTooltipErrorXS2: "--",
      humidityTooltipErrorXP4: "--",
      humidityTooltipErrorXS3: "--",
      humidityTooltipErrorXP5: "--",
      humidityTooltipErrorXP6: "--",
      humidityTooltipErrorXS4: "--",
      humidityTooltipErrorXP7: "--",
      steelBoxHuangshiHumidityTooltipError1: "--",
      steelBoxHuangshiHumidityTooltipError2: "--",
      steelBoxHuanggangHumidityTooltipError1: "--",
      steelBoxHuanggangHumidityTooltipError2: "--",
      mainCableHuanggangHumidityTooltipError: "--",
      mainCableHuangshiHumidityTooltipError: "--",
      anchorRoomHuangshiWestHumidityTooltipError: "--",
      anchorRoomHuanggangWestHumidityTooltipError: "--",
      anchorRoomHuangshiEastHumidityTooltipError: "--",
      anchorRoomHuanggangEastHumidityTooltipError: "--",
      saddleRoomHuangshiUpstreamHumidityTooltipError: "--",
      saddleRoomHuangshiDownstreamHumidityTooltipError: "--",
      saddleRoomHuanggangUpstreamHumidityTooltipError: "--",
      saddleRoomHuanggangDownstreamHumidityTooltipError: "--",
      humidityTooltipErrorDP1: "--",
      humidityTooltipErrorDS1: "--",
      humidityTooltipErrorDP2: "--",
      humidityTooltipErrorDP3: "--",
      humidityTooltipErrorDS2: "--",
      humidityTooltipErrorDP4: "--",
      humidityTooltipErrorDS3: "--",
      humidityTooltipErrorDP5: "--",
      humidityTooltipErrorDP6: "--",
      humidityTooltipErrorDS4: "--",
      humidityTooltipErrorDP7: "--",
      steelBoxSideSpanUpstreamTooltipError: "--",
      steelBoxSideSpanDownstreamTooltipError: "--",

      //malfunction
      steelBoxHuangshiMalfunction1: "--",
      steelBoxHuangshiMalfunction2: "--",
      steelBoxHuanggangMalfunction1: "--",
      steelBoxHuanggangMalfunction2: "--",
      mainCableHuanggangMalfunction: "--",
      mainCableHuangshiMalfunction: "--",
      anchorRoomHuangshiWestMalfunction: "--",
      anchorRoomHuanggangWestMalfunction: "--",
      anchorRoomHuangshiEastMalfunction: "--",
      anchorRoomHuanggangEastMalfunction: "--",
      steelBoxSideSpanUpstreamMalfunction: "--",
      steelBoxSideSpanDownstreamMalfunction: "--",

      dataNameIdDict: {
        humidityXP1: "a590aff8-a032-466c-808a-0197716e6d8f",
        temperatureXP1: "a33ce3be-90a4-4bf4-a0ab-33cfa7a93bea",
        humidityXS1: "c77a0d55-aafb-4a15-938b-fde1c21d8641",
        temperatureXS1: "9fce4644-b14c-4727-bd85-2247ac36f017",
        humidityXP2: "db774787-6c3c-4494-a0bf-d333875f7cd5",
        temperatureXP2: "9bc8e289-0ffa-44d1-974a-2c36b77c0274",
        humidityXP3: "bdad3d50-0689-4e2d-b352-5fc3737fc3c1",
        temperatureXP3: "e85a00f8-512e-4b55-b966-4fbf80fbb4e5",
        humidityXS2: "d42e5020-099d-460e-9ee8-3da3a421cc4c",
        temperatureXS2: "45740b7a-5f9c-47fd-aa65-e9540c98e18c",
        humidityXP4: "afbc6366-d99b-4ba3-b3aa-23557c7bda31",
        temperatureXP4: "2c9dc168-917a-4eff-9d4a-ca856531eb03",
        humidityXS3: "701a082e-0ef6-49b7-a6c7-68986ee48f61",
        temperatureXS3: "43c38b35-fdc3-42a3-8ece-4a83cb8742af",
        humidityXP5: "068730fa-fa80-4024-91eb-4e11a9d8c602",
        temperatureXP5: "42d65cc2-95c3-4066-905d-eab9648407f4",
        humidityXP6: "043df115-873c-4321-8e9a-d8f65e7c50ae",
        temperatureXP6: "a0a58489-432f-40c0-aead-3635327b009a",
        humidityXS4: "f8af3074-81d7-45fa-a40d-4d971b7b445c",
        temperatureXS4: "1ef8c2e2-ad6b-4519-bb92-c89df81ad387",
        humidityXP7: "e980f39a-f98f-4363-8b45-22a23db888f2",
        temperatureXP7: "0d6377b4-fde1-43fd-981d-2042225039f4",

        humidityDP1: "4f1de2ce-a1ee-4761-b140-b42241ad26f1",
        temperatureDP1: "7ba0aa1a-4290-45eb-baf0-feed6982db5b",
        humidityDS1: "82d8fa7c-9da6-46f4-864f-35b50815102b",
        temperatureDS1: "05898f17-eb22-4525-baf8-4c814e9b44e7",
        humidityDP2: "ab97984e-a5c1-4abc-92ba-3ca24f5b4b71",
        temperatureDP2: "f469668a-b2f1-40f2-b56b-ff74e314c635",
        humidityDP3: "0b5e3507-ae33-45e1-968d-3d6c823fe491",
        temperatureDP3: "32ea95b9-84a0-44b8-9d12-d0a3ae3a4979",
        humidityDS2: "fa674ad3-ce9a-44b8-aed0-70c079ede7c7",
        temperatureDS2: "9581234e-9070-47d6-a2f4-e15ab7433527",
        humidityDP4: "1f7703b2-c263-4b03-9761-aaa47410a3e7",
        temperatureDP4: "5dcc1744-69a0-4cda-acd7-e2f3055526a6",
        humidityDS3: "33288d62-8aaf-4d92-8bf2-5f7cd3918b81",
        temperatureDS3: "733c96cd-da3a-45a7-941d-93fe37a19aa0",
        humidityDP5: "6cbc7808-eb3e-4810-84fa-14682af0c4a9",
        temperatureDP5: "f858c8d9-f9bf-49c8-8ee6-59a692895d43",
        humidityDP6: "207de5ed-b719-4a19-ab48-13e4e3120cf2",
        temperatureDP6: "a1e32417-a478-446a-89e4-575eb2200d2b",
        humidityDS4: "e7c2bb8a-810e-4d18-bf3b-d3113e7f6520",
        temperatureDS4: "14945e39-d7f9-403c-8efb-3769da0b69f9",
        humidityDP7: "029aacc8-e5fd-46c5-8af1-06e890ca1465",
        temperatureDP7: "6aa26141-b382-48ba-b19e-0436977ddf7e",

        steelBoxHuangshiTemperature1: "d7fb8ea7-0159-46b3-8e08-790bd488b4c9",
        steelBoxHuangshiHumidity1: "90fe68e3-37fa-46cd-af5a-ec7de88076fd",
        steelBoxHuangshiRunning1: "5a431643-9aea-44d7-910b-2e9b3ebd3898",
        steelBoxHuangshiTemperature2: "3612fc0b-9e8a-4e1c-83d4-8627c9cc28f3",
        steelBoxHuangshiHumidity2: "9a95e45e-fc69-4bcf-a19a-8be91ba9ca37",
        steelBoxHuangshiRunning2: "cde48faf-c672-4945-b4bb-5878e9fde672",
        steelBoxHuanggangTemperature1: "29f4a908-0494-444b-9591-8943c41ff275",
        steelBoxHuanggangHumidity1: "17805a2a-a164-4763-8df0-e2b59b5b9e2c",
        steelBoxHuanggangRunning1: "ce5036f9-7274-4e93-8c75-3a318713cb52",
        steelBoxHuanggangTemperature2: "d4c9548d-68d6-4630-ad41-1eff52378c0d",
        steelBoxHuanggangHumidity2: "e5305c0f-3601-4cb8-a2a7-0cbe8938d2d5",
        steelBoxHuanggangRunning2: "e09582d1-135f-4b2a-a5c9-dfad86486d8e",

        mainCableHuanggangHumidity: "b3284829-bd97-40d4-a5a4-bf0f1f4a02f9",
        mainCableHuanggangTemperature: "8ab01974-bc13-4c6c-adc8-0f18a4052d7f",
        mainCableHuanggangRunning: "b9c14b49-76ae-43fc-ba12-a3886e212607",
        mainCableHuangshiHumidity: "fcf120ea-3c0f-4083-9d8e-2449d7582cd9",
        mainCableHuangshiTemperature: "5bc51846-7f7e-4c80-b3ab-3c9493ed0a0b",
        mainCableHuangshiRunning: "1adc3926-3e4a-4761-bdf5-08b9b8c06f23",

        anchorRoomHuangshiWestTemperature: "4ce8ec90-6f34-4be5-b555-c594577dd08d",
        anchorRoomHuangshiWestHumidity: "9d2db37b-fd6c-499c-8908-d867df89e494",
        anchorRoomHuangshiWestRunning: "4d169189-b1b4-4444-bd50-310393f091cf",
        anchorRoomHuanggangWestTemperature: "1b2ad488-6486-4a12-a7e2-e41f18e91ea1",
        anchorRoomHuanggangWestHumidity: "bea24abe-41e2-441f-88d1-dfc900d85cc5",
        anchorRoomHuanggangWestRunning: "0ae8cea1-07fb-4eef-bbe6-3026a50f3c62",
        anchorRoomHuangshiEastTemperature: "bd9268c1-c94d-4b47-9b90-28b8a5d57392",
        anchorRoomHuangshiEastHumidity: "69f351cc-5d00-4722-8b24-c51b5248552a",
        anchorRoomHuangshiEastRunning: "aa5b8a1e-b39b-4dbd-90bf-c7703247d1c3",
        anchorRoomHuanggangEastTemperature: "129e5e3b-b2b0-4e8f-a343-82a1189d242c",
        anchorRoomHuanggangEastHumidity: "2dc47b6f-7fdd-4d37-91ee-702d3d511f81",
        anchorRoomHuanggangEastRunning: "aa0f6edc-6b6f-4a4d-acef-1de902f512dd",

        steelBoxSideSpanUpstreamRunning: "d5cd3b64-9965-49cf-a5fc-bbc520a7964e",
        steelBoxSideSpanDownstreamRunning: "7c696af8-cb69-40e6-902b-eee78ba0be2f",

        saddleRoomHuangshiUpstreamTemperature: "920552fe-972d-4dfd-9c4a-6dbf1c0267bc",
        saddleRoomHuangshiUpstreamHumidity: "f51153cc-908a-49e9-8aa7-6a6566c7a3c1",
        saddleRoomHuangshiDownstreamTemperature: "77729839-07e0-4c9f-be3e-538170da7cb4",
        saddleRoomHuangshiDownstreamHumidity: "fa3ad960-575b-481f-93af-932e6602398d",
        saddleRoomHuanggangUpstreamTemperature: "57631686-3e5e-4aad-8148-0f2f4e34bee4",
        saddleRoomHuanggangUpstreamHumidity: "dcbaf75d-6674-43c8-b21f-24bf879b53a2",
        saddleRoomHuanggangDownstreamTemperature: "5615cdaf-dc8f-44a1-a943-8b5086b71c40",
        saddleRoomHuanggangDownstreamHumidity: "9b253c1f-cdf3-4f50-a3fb-a4fc74724973",

        steelBoxHuangshiMalfunction1: "e7af13df-e306-457e-8b5a-40193585ac4b",
        steelBoxHuangshiMalfunction2: "37faac91-8b8e-4c07-b178-9b93cbdd2a2f",
        steelBoxHuanggangMalfunction1: "22f54911-c708-4964-8a29-d935a9cce32b",
        steelBoxHuanggangMalfunction2: "9062a4b5-a450-450a-b4e9-1376692a6571",
        mainCableHuanggangMalfunction: "2325021c-df6a-4145-a97e-cd65750b8644",
        mainCableHuangshiMalfunction: "f5b859cf-a09e-4580-9b66-bc4cad41cff3",
        anchorRoomHuangshiWestMalfunction: "37e82cb6-7714-4270-821e-751d8d299180",
        anchorRoomHuanggangWestMalfunction: "1b944ea7-0a39-47c5-bae8-00826b92189b",
        anchorRoomHuangshiEastMalfunction: "1405423d-4fc4-4e21-89da-2791b0d89e06",
        anchorRoomHuanggangEastMalfunction: "e60b7611-bb25-4cf4-8ad1-9878277a65e3",
        steelBoxSideSpanUpstreamMalfunction: "362f4b2b-cc8f-4a1e-b205-4a80debb4d9d",
        steelBoxSideSpanDownstreamMalfunction: "92af9411-ffa3-436b-8d01-d29a39ed600f",
      },
      allowedMaxNameIdDict: {
        humidityAllowedMaxXP1: "a590aff8-a032-466c-808a-0197716e6d8f",
        humidityAllowedMaxXS1: "c77a0d55-aafb-4a15-938b-fde1c21d8641",
        humidityAllowedMaxXP2: "db774787-6c3c-4494-a0bf-d333875f7cd5",
        humidityAllowedMaxXP3: "bdad3d50-0689-4e2d-b352-5fc3737fc3c1",
        humidityAllowedMaxXS2: "d42e5020-099d-460e-9ee8-3da3a421cc4c",
        humidityAllowedMaxXP4: "afbc6366-d99b-4ba3-b3aa-23557c7bda31",
        humidityAllowedMaxXS3: "701a082e-0ef6-49b7-a6c7-68986ee48f61",
        humidityAllowedMaxXP5: "068730fa-fa80-4024-91eb-4e11a9d8c602",
        humidityAllowedMaxXP6: "043df115-873c-4321-8e9a-d8f65e7c50ae",
        humidityAllowedMaxXS4: "f8af3074-81d7-45fa-a40d-4d971b7b445c",
        humidityAllowedMaxXP7: "e980f39a-f98f-4363-8b45-22a23db888f2",
        humidityAllowedMaxDP1: "4f1de2ce-a1ee-4761-b140-b42241ad26f1",
        humidityAllowedMaxDS1: "82d8fa7c-9da6-46f4-864f-35b50815102b",
        humidityAllowedMaxDP2: "ab97984e-a5c1-4abc-92ba-3ca24f5b4b71",
        humidityAllowedMaxDP3: "0b5e3507-ae33-45e1-968d-3d6c823fe491",
        humidityAllowedMaxDS2: "fa674ad3-ce9a-44b8-aed0-70c079ede7c7",
        humidityAllowedMaxDP4: "1f7703b2-c263-4b03-9761-aaa47410a3e7",
        humidityAllowedMaxDS3: "33288d62-8aaf-4d92-8bf2-5f7cd3918b81",
        humidityAllowedMaxDP5: "6cbc7808-eb3e-4810-84fa-14682af0c4a9",
        humidityAllowedMaxDP6: "207de5ed-b719-4a19-ab48-13e4e3120cf2",
        humidityAllowedMaxDS4: "e7c2bb8a-810e-4d18-bf3b-d3113e7f6520",
        humidityAllowedMaxDP7: "029aacc8-e5fd-46c5-8af1-06e890ca1465",
        steelBoxHuangshiHumidityAllowedMax1: "90fe68e3-37fa-46cd-af5a-ec7de88076fd",
        steelBoxHuangshiHumidityAllowedMax2: "9a95e45e-fc69-4bcf-a19a-8be91ba9ca37",
        steelBoxHuanggangHumidityAllowedMax1: "17805a2a-a164-4763-8df0-e2b59b5b9e2c",
        steelBoxHuanggangHumidityAllowedMax2: "e5305c0f-3601-4cb8-a2a7-0cbe8938d2d5",
        mainCableHuanggangHumidityAllowedMax: "b3284829-bd97-40d4-a5a4-bf0f1f4a02f9",
        mainCableHuangshiHumidityAllowedMax: "fcf120ea-3c0f-4083-9d8e-2449d7582cd9",
        anchorRoomHuangshiWestHumidityAllowedMax: "9d2db37b-fd6c-499c-8908-d867df89e494",
        anchorRoomHuanggangWestHumidityAllowedMax: "bea24abe-41e2-441f-88d1-dfc900d85cc5",
        anchorRoomHuangshiEastHumidityAllowedMax: "69f351cc-5d00-4722-8b24-c51b5248552a",
        anchorRoomHuanggangEastHumidityAllowedMax: "2dc47b6f-7fdd-4d37-91ee-702d3d511f81",
        saddleRoomHuangshiUpstreamHumidityAllowedMax: "f51153cc-908a-49e9-8aa7-6a6566c7a3c1",
        saddleRoomHuangshiDownstreamHumidityAllowedMax: "fa3ad960-575b-481f-93af-932e6602398d",
        saddleRoomHuanggangUpstreamHumidityAllowedMax: "dcbaf75d-6674-43c8-b21f-24bf879b53a2",
        saddleRoomHuanggangDownstreamHumidityAllowedMax: "9b253c1f-cdf3-4f50-a3fb-a4fc74724973",
      },
      dataNameErrorNameDict: {
        humidityXP1: "errorXP1",
        temperatureXP1: "errorXP1",
        humidityXS1: "errorXS1",
        temperatureXS1: "errorXS1",
        humidityXP2: "errorXP2",
        temperatureXP2: "errorXP2",
        humidityXP3: "errorXP3",
        temperatureXP3: "errorXP3",
        humidityXS2: "errorXS2",
        temperatureXS2: "errorXS2",
        humidityXP4: "errorXP4",
        temperatureXP4: "errorXP4",
        humidityXS3: "errorXS3",
        temperatureXS3: "errorXS3",
        humidityXP5: "errorXP5",
        temperatureXP5: "errorXP5",
        humidityXP6: "errorXP6",
        temperatureXP6: "errorXP6",
        humidityXS4: "errorXS4",
        temperatureXS4: "errorXS4",
        humidityXP7: "errorXP7",
        temperatureXP7: "errorXP7",

        humidityDP1: "errorDP1",
        temperatureDP1: "errorDP1",
        humidityDS1: "errorDS1",
        temperatureDS1: "errorDS1",
        humidityDP2: "errorDP2",
        temperatureDP2: "errorDP2",
        humidityDP3: "errorDP3",
        temperatureDP3: "errorDP3",
        humidityDS2: "errorDS2",
        temperatureDS2: "errorDS2",
        humidityDP4: "errorDP4",
        temperatureDP4: "errorDP4",
        humidityDS3: "errorDS3",
        temperatureDS3: "errorDS3",
        humidityDP5: "errorDP5",
        temperatureDP5: "errorDP5",
        humidityDP6: "errorDP6",
        temperatureDP6: "errorDP6",
        humidityDS4: "errorDS4",
        temperatureDS4: "errorDS4",
        humidityDP7: "errorDP7",
        temperatureDP7: "errorDP7",

        steelBoxHuangshiTemperature1: "steelBoxHuangshiError1",
        steelBoxHuangshiHumidity1: "steelBoxHuangshiError1",
        steelBoxHuangshiTemperature2: "steelBoxHuangshiError2",
        steelBoxHuangshiHumidity2: "steelBoxHuangshiError2",
        steelBoxHuanggangTemperature1: "steelBoxHuanggangError1",
        steelBoxHuanggangHumidity1: "steelBoxHuanggangError1",
        steelBoxHuanggangTemperature2: "steelBoxHuanggangError2",
        steelBoxHuanggangHumidity2: "steelBoxHuanggangError2",

        mainCableHuangshiHumidity: "mainCableHuangshiError",
        mainCableHuangshiTemperature: "mainCableHuangshiError",
        mainCableHuanggangHumidity: "mainCableHuanggangError",
        mainCableHuanggangTemperature: "mainCableHuanggangError",

        anchorRoomHuangshiWestTemperature: "anchorRoomHuangshiWestError",
        anchorRoomHuangshiWestHumidity: "anchorRoomHuangshiWestError",
        anchorRoomHuanggangWestTemperature: "anchorRoomHuanggangWestError",
        anchorRoomHuanggangWestHumidity: "anchorRoomHuanggangWestError",
        anchorRoomHuangshiEastTemperature: "anchorRoomHuangshiEastError",
        anchorRoomHuangshiEastHumidity: "anchorRoomHuangshiEastError",
        anchorRoomHuanggangEastTemperature: "anchorRoomHuanggangEastError",
        anchorRoomHuanggangEastHumidity: "anchorRoomHuanggangEastError",

        steelBoxSideSpanUpstreamRunning: "steelBoxSideSpanUpstreamError",
        steelBoxSideSpanDownstreamRunning: "steelBoxSideSpanDownstreamError",

        saddleRoomHuangshiUpstreamTemperature: "saddleRoomHuangshiError",
        saddleRoomHuangshiUpstreamHumidity: "saddleRoomHuangshiError",
        saddleRoomHuangshiDownstreamTemperature: "saddleRoomHuangshiError",
        saddleRoomHuangshiDownstreamHumidity: "saddleRoomHuangshiError",
        saddleRoomHuanggangUpstreamTemperature: "saddleRoomHuanggangError",
        saddleRoomHuanggangUpstreamHumidity: "saddleRoomHuanggangError",
        saddleRoomHuanggangDownstreamTemperature: "saddleRoomHuanggangError",
        saddleRoomHuanggangDownstreamHumidity: "saddleRoomHuanggangError",
      },
      dataNameTooltipErrorNameDict: {
        humidityXP1: "humidityTooltipErrorXP1",
        humidityXS1: "humidityTooltipErrorXS1",
        humidityXP2: "humidityTooltipErrorXP2",
        humidityXP3: "humidityTooltipErrorXP3",
        humidityXS2: "humidityTooltipErrorXS2",
        humidityXP4: "humidityTooltipErrorXP4",
        humidityXS3: "humidityTooltipErrorXS3",
        humidityXP5: "humidityTooltipErrorXP5",
        humidityXP6: "humidityTooltipErrorXP6",
        humidityXS4: "humidityTooltipErrorXS4",
        humidityXP7: "humidityTooltipErrorXP7",
        humidityDP1: "humidityTooltipErrorDP1",
        humidityDS1: "humidityTooltipErrorDS1",
        humidityDP2: "humidityTooltipErrorDP2",
        humidityDP3: "humidityTooltipErrorDP3",
        humidityDS2: "humidityTooltipErrorDS2",
        humidityDP4: "humidityTooltipErrorDP4",
        humidityDS3: "humidityTooltipErrorDS3",
        humidityDP5: "humidityTooltipErrorDP5",
        humidityDP6: "humidityTooltipErrorDP6",
        humidityDS4: "humidityTooltipErrorDS4",
        humidityDP7: "humidityTooltipErrorDP7",
        steelBoxHuangshiHumidity1: "steelBoxHuangshiHumidityTooltipError1",
        steelBoxHuangshiHumidity2: "steelBoxHuangshiHumidityTooltipError2",
        steelBoxHuanggangHumidity1: "steelBoxHuanggangHumidityTooltipError1",
        steelBoxHuanggangHumidity2: "steelBoxHuanggangHumidityTooltipError2",
        mainCableHuangshiHumidity: "mainCableHuangshiHumidityTooltipError",
        mainCableHuanggangHumidity: "mainCableHuanggangHumidityTooltipError",
        anchorRoomHuangshiWestHumidity: "anchorRoomHuangshiWestHumidityTooltipError",
        anchorRoomHuanggangWestHumidity: "anchorRoomHuanggangWestHumidityTooltipError",
        anchorRoomHuangshiEastHumidity: "anchorRoomHuangshiEastHumidityTooltipError",
        anchorRoomHuanggangEastHumidity: "anchorRoomHuanggangEastHumidityTooltipError",
        saddleRoomHuangshiUpstreamHumidity: "saddleRoomHuangshiUpstreamHumidityTooltipError",
        saddleRoomHuangshiDownstreamHumidity: "saddleRoomHuangshiDownstreamHumidityTooltipError",
        saddleRoomHuanggangUpstreamHumidity: "saddleRoomHuanggangUpstreamHumidityTooltipError",
        saddleRoomHuanggangDownstreamHumidity: "saddleRoomHuanggangDownstreamHumidityTooltipError",
      },
      malfunctionDataNameErrorNameDict: {
        steelBoxHuangshiMalfunction1: "steelBoxHuangshiError1",
        steelBoxHuangshiMalfunction2: "steelBoxHuangshiError2",
        steelBoxHuanggangMalfunction1: "steelBoxHuanggangError1",
        steelBoxHuanggangMalfunction2: "steelBoxHuanggangError2",
        mainCableHuanggangMalfunction: "mainCableHuanggangError",
        mainCableHuangshiMalfunction: "mainCableHuangshiError",
        anchorRoomHuangshiWestMalfunction: "anchorRoomHuangshiWestError",
        anchorRoomHuanggangWestMalfunction: "anchorRoomHuanggangWestError",
        anchorRoomHuangshiEastMalfunction: "anchorRoomHuangshiEastError",
        anchorRoomHuanggangEastMalfunction: "anchorRoomHuanggangEastError",
        steelBoxSideSpanUpstreamMalfunction: "steelBoxSideSpanUpstreamError",
        steelBoxSideSpanDownstreamMalfunction: "steelBoxSideSpanDownstreamError",
      },
      // dataNameRunningTooltipNameDict: {
      //   steelBoxHuangshiRunning1: "steelBoxHuangshiRunningTooltip1",
      //   steelBoxHuangshiRunning2: "steelBoxHuangshiRunningTooltip2",
      //   steelBoxHuanggangRunning1: "steelBoxHuanggangRunningTooltip1",
      //   steelBoxHuanggangRunning2: "steelBoxHuanggangRunningTooltip2",

      //   mainCableHuangshiRunning: "mainCableHuangshiRunningTooltip",
      //   mainCableHuanggangRunning: "mainCableHuanggangRunningTooltip",

      //   anchorRoomHuangshiWestRunning: "anchorRoomHuangshiWestRunningTooltip",
      //   anchorRoomHuanggangWestRunning: "anchorRoomHuanggangWestRunningTooltip",
      //   anchorRoomHuangshiEastRunning: "anchorRoomHuangshiEastRunningTooltip",
      //   anchorRoomHuanggangEastRunning: "anchorRoomHuanggangEastRunningTooltip",

      //   steelBoxSideSpanUpstreamRunning: "steelBoxSideSpanUpstreamRunningTooltip",
      //   steelBoxSideSpanDownstreamRunning: "steelBoxSideSpanDownstreamRunningTooltip",
      // },
      dataNameRunningClassNameDict: {
        steelBoxHuangshiRunning1: "steelBoxHuangshiRunningClass1",
        steelBoxHuangshiRunning2: "steelBoxHuangshiRunningClass2",
        steelBoxHuanggangRunning1: "steelBoxHuanggangRunningClass1",
        steelBoxHuanggangRunning2: "steelBoxHuanggangRunningClass2",

        mainCableHuangshiRunning: "mainCableHuangshiRunningClass",
        mainCableHuanggangRunning: "mainCableHuanggangRunningClass",

        anchorRoomHuangshiWestRunning: "anchorRoomHuangshiWestRunningClass",
        anchorRoomHuanggangWestRunning: "anchorRoomHuanggangWestRunningClass",
        anchorRoomHuangshiEastRunning: "anchorRoomHuangshiEastRunningClass",
        anchorRoomHuanggangEastRunning: "anchorRoomHuanggangEastRunningClass",

        steelBoxSideSpanUpstreamRunning: "steelBoxSideSpanUpstreamRunningClass",
        steelBoxSideSpanDownstreamRunning: "steelBoxSideSpanDownstreamRunningClass",
      },
      stationIdList: [
        "377be203-2077-4b3f-b81a-c624dfbd9b6b",
        "07b2d2f0-316f-475f-ac72-85868c518bed",
        "459dbd7c-ea48-4677-abf5-b0f828d92546",
        "d794781b-27f8-464c-ab22-35b1833bc116",
        "e243af22-1e95-4c0e-ac31-ec1966b10d7c",
        "0e0dca90-fd50-434e-86ae-9915c6722578",
        "92752eef-ef6f-4d9a-84d9-7b0b5bc5b119",
        "f11f5cc2-e9d9-4ed3-ace9-cf9e6d15c345",
        "c4a46498-ff86-4a44-a340-25a65d2106a1",
        "bcad1ee7-a3e9-4a7f-96d9-8d348fabfb4a",
        "ed0e693b-8bd6-4d68-ba79-a19525538d1e",
        "31625e60-63a0-4aee-a340-094cf7a82092",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (runningFlag > 0) {
        if (result.length > 0) {
          result += ", ";
        }
        result += "除湿机运行";
      } else if (runningFlag === 0) {
        if (result.length > 0) {
          result += ", ";
        }
        result += "除湿机停止";
      }

      if (errorFlag > 0) {
        if (result.length > 0) {
          result += ", ";
        }
        result += "故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}
.tooltip-slot {
  line-height: 1.4;
}
.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
 // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 320px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/qipanzhou/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
          &-left-anchor {
            top: 255px;
            left: 24px;
          }
          &-left {
            top: 230px;
            left: 259px;
          }
          &-right {
            top: 230px;
            left: 916px;
          }
          &-left-top {
            top: 145px;
            left: 259px;
          }
          &-right-top {
            top: 145px;
            left: 916px;
          }
          &-right-anchor {
            top: 250px;
            left: 1125px;
          }
        }
        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }
        .sta-left-anchor {
          top: 242px;
          left: 230px;
          &::before {
            top: 24px;
            left: -245px;
            transform: rotate(0deg);
          }
          &:after {
            top: 24px;
            left: -256px;
          }
          .state-info {
            left: -382px;
            top: 25px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }
        .sta-left-steelbox {
          top: 242px;
          left: 309px;
          &::before {
            top: 24px;
            left: -45px;
            transform: rotate(229deg);
          }
          &:after {
            top: 43px;
            left: -4px;
          }
          .state-info {
            left: 13px;
            top: 44px;
          }
        }
        .sta-left-side-span {
          top: 242px;
          left: 268px;
          &::before {
            top: 24px;
            left: -41px;
            transform: rotate(131deg);
          }
          &:after {
            top: 43px;
            left: -47px;
          }
          .state-info {
            right: 49px;
            top: 44px;
          }
        }

        .sta-left-top {
          top: 170px;
          left: 238px;
          &::before {
            bottom: 75px;
            left: -43px;
            transform: rotate(80deg);
            width: 130px;
          }
          &::after {
            bottom: 138px;
            left: -4px;
          }
          .state-info {
            left: -134px;
            top: -139px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }
        .sta-left-top-saddle {
          top: 170px;
          left: 238px;
          &::before {
            bottom: 75px;
            left: -43px;
            transform: rotate(80deg);
            width: 130px;
          }
          &::after {
            bottom: 138px;
            left: -4px;
          }
          .state-info {
            left: -146px;
            top: -138px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }
        .sta-right-steelbox {
          top: 242px;
          left: 963px;
          &::before {
            top: 24px;
            left: -45px;
            transform: rotate(240deg);
            width: 50px;
          }
          &:after {
            top: 45px;
            left: -8px;
          }
          .state-info {
            left: 8px;
            top: 46px;
          }
        }

        .sta-right-top {
          top: 170px;
          left: 920px;
          &::before {
            bottom: 75px;
            left: -43px;
            transform: rotate(100deg);
            width: 130px;
          }
          &::after {
            bottom: 138px;
            left: 32px;
          }
          .state-info {
            left: 48px;
            top: -139px;
          }
        }
        .sta-right-top-saddle {
          top: 170px;
          left: 920px;
          &::before {
            bottom: 75px;
            left: -43px;
            transform: rotate(100deg);
            width: 130px;
          }
          &::after {
            bottom: 138px;
            left: 32px;
          }
          .state-info {
            left: 48px;
            top: -138px;
          }
        }
        .sta-right-anchor {
          top: 235px;
          left: 1390px;
          &::before {
            top: 24px;
            left: -245px;
            transform: rotate(0deg);
          }
          &:after {
            top: 24px;
            left: -195px;
          }
          .state-info {
            left: -180px;
            top: 25px;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }
        .left1 {
          top: 236px;
          left: 65px;
          &::before {
            bottom: 35px;
            left: -63px;
            width: 90px;
            transform: rotate(48deg);
          }
          &::after {
            bottom: 68px;
            left: -62px;
          }
          .state-info {
            right: 80px;
            top: -53px;
          }
        }
        .left2 {
          top: 199px;
          left: 155px;
          &::before {
            bottom: 35px;
            left: -63px;
            width: 90px;
            transform: rotate(48deg);
          }
          &::after {
            bottom: 68px;
            left: -62px;
          }
          .state-info {
            right: 80px;
            top: -53px;
          }
        }
        .left3 {
          top: 160px;
          left: 245px;
          &::before {
            bottom: 35px;
            left: -63px;
            width: 90px;
            transform: rotate(48deg);
          }
          &::after {
            bottom: 68px;
            left: -62px;
          }
          .state-info {
            right: 80px;
            top: -53px;
          }
        }
        .left4 {
          top: 170px;
          left: 305px;
          &::before {
            bottom: 45px;
            left: -17px;
            transform: rotate(118deg);
            width: 90px;
          }
          &::after {
            bottom: 85px;
            left: 48px;
          }
          .state-info {
            left: 64px;
            top: -70px;
          }
        }
        .left5 {
          top: 205px;
          left: 415px;
          &::before {
            bottom: 45px;
            left: -17px;
            transform: rotate(118deg);
            width: 90px;
          }
          &::after {
            bottom: 85px;
            left: 48px;
          }
          .state-info {
            left: 64px;
            top: -70px;
          }
        }

        .middle {
          top: 230px;
          left: 590px;
          &::before {
            top: 35px;
            left: -3px;
            transform: rotate(229deg);
            width: 65px;
          }
          &:after {
            top: 59px;
            left: 50px;
          }
          .state-info {
            left: 65px;
            top: 60px;
          }
        }

        .right1 {
          top: 236px;
          left: 1100px;
          &::before {
            bottom: 35px;
            left: -12px;
            width: 90px;
            transform: rotate(132deg);
          }
          &::after {
            bottom: 68px;
            left: 62px;
          }
          .state-info {
            right: -137px;
            top: -53px;
          }
        }
        .right2 {
          top: 199px;
          left: 1017px;
          &::before {
            bottom: 35px;
            left: -12px;
            width: 90px;
            transform: rotate(132deg);
          }
          &::after {
            bottom: 68px;
            left: 62px;
          }
          .state-info {
            right: -137px;
            top: -53px;
          }
        }
        .right3 {
          top: 160px;
          left: 938px;
          &::before {
            bottom: 35px;
            left: -12px;
            width: 90px;
            transform: rotate(132deg);
          }
          &::after {
            bottom: 68px;
            left: 62px;
          }
          .state-info {
            right: -137px;
            top: -53px;
          }
        }
        .right4 {
          top: 170px;
          left: 880px;
          &::before {
            bottom: 45px;
            left: -58px;
            transform: rotate(62deg);
            width: 90px;
          }
          &::after {
            bottom: 85px;
            left: -48px;
          }
          .state-info {
            left: -124px;
            top: -70px;
          }
        }
        .right5 {
          top: 205px;
          left: 760px;
          &::before {
            bottom: 45px;
            left: -58px;
            transform: rotate(62deg);
            width: 90px;
          }
          &::after {
            bottom: 85px;
            left: -48px;
          }
          .state-info {
            left: -124px;
            top: -70px;
          }
        }
      }
    }
  }
}
</style>